/* Original name @uswitch/trustyle.button-link */
/** @jsx jsx */
import React from 'react'
import { jsx, useThemeUI } from 'theme-ui'
import { path } from '../../utils/obj'
import { DynamicSparkIcon } from '../helpers/dynamic-spark-icon'
import { Link } from '../helpers/react'

export const ButtonLink = ({
  children,
  variant,
  size = 'large',
  beforeIcon,
  afterIcon,
  onClick = () => {},
  ...props
}) => {
  const { theme } = useThemeUI()

  const displayIcon = (type, icon) => {
    return (
      <div
        sx={{
          display: 'inline',
          variant: `elements.buttons.variants.${variant}.${type}`,
        }}
      >
        <DynamicSparkIcon
          glyph={icon}
          color={path(`elements.buttons.variants.${variant}.color`.split('.'), theme, 'base')}
          direction='right'
          size={22}
        />
      </div>
    )
  }

  return (
    <Link
      sx={{
        cursor: 'pointer',
        backgroundImage: 'none',
        fontFamily: 'base',
        fontSize: path(`elements.buttons.base.btnSize.${size}.fontSize`.split('.'), theme, 'base'),
        paddingX: path(`elements.buttons.base.btnSize.${size}.paddingX`.split('.'), theme, 'sm'),
        paddingY: path(`elements.buttons.base.btnSize.${size}.paddingY`.split('.'), theme, 'base'),
        height: path(`elements.buttons.base.btnSize.${size}.height`.split('.'), theme, 'base'),
        width:
          size === 'fullWidth'
            ? path(`elements.buttons.base.btnSize.${size}.width`.split('.'), theme, 'base')
            : 'unset',
        display: 'inline-block',
        textDecoration: 'none',
        variant: `elements.buttons.variants.${variant}`,
      }}
      onClick={onClick}
      {...props}
    >
      <If condition={beforeIcon}>{displayIcon('beforeIcon', beforeIcon)}</If>
      <div
        sx={{
          display: 'inline',
          backgroundColor: 'inherit',
          variant: `elements.buttons.variants.${variant}.content`,
        }}
      >
        {children}
      </div>
      <If condition={afterIcon}>{displayIcon('afterIcon', afterIcon)}</If>
    </Link>
  )
}
